import { createAuthGuard } from 'keycloak-angular';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const AppAuthGuard = createAuthGuard(async (route, state, authData) => {
  const router = inject(Router);
  const { authenticated, grantedRoles, keycloak } = authData;

  // Force the user to log in if currently unauthenticated.
  if (!authenticated) {
    await keycloak.login({
      redirectUri: window.location.origin + state.url,
    });
    return false;
  }

  // Get the roles required from the route.
  const requiredRoles = route.data['roles'] as string[] | undefined;

  // Allow the user to proceed if no additional roles are required to access the route.
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  // Combine realm and resource roles
  const allRoles = [
    ...grantedRoles.realmRoles,
    ...Object.values(grantedRoles.resourceRoles).flat()
  ];

  // Allow the user to proceed if all the required roles are present.
  const granted = requiredRoles.every((role) => allRoles.includes(role));

  // Routing user into permission denied view if don't have necessary roles.
  if (!granted) {
    return router.createUrlTree(['permission-denied']);
  }

  return granted;
});
